import React from 'react';
import { bool, string } from 'prop-types';
import cx from 'classnames';

import useStyles from 'hooks/useStyles';

import styles from './UpcomingPlayer.scss';

const UpcomingPlayer = ({ image, title, description, showTime }) => {
  useStyles(styles);

  return (
    <div className={cx(styles.root, styles.comingSoon)}>
      <img className={styles.comingSoonImage} src={image} alt="" />
      <h4 className={styles.title}>{title}</h4>
      {showTime && <p className={styles.description}>{description}</p>}
    </div>
  );
};

UpcomingPlayer.propTypes = {
  image: string.isRequired,
  title: string.isRequired,
  description: string.isRequired,
  showTime: bool.isRequired,
};

export default UpcomingPlayer;
